module.exports = __webpack_public_path__ + "static/medinol-d4725be5891acde1b44f573ea45a0bc6.svg";